import { render, staticRenderFns } from "./PhuSidebar.vue?vue&type=template&id=d2eac8a4&scoped=true"
import script from "./PhuSidebar.vue?vue&type=script&lang=js"
export * from "./PhuSidebar.vue?vue&type=script&lang=js"
import style0 from "./PhuSidebar.vue?vue&type=style&index=0&id=d2eac8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2eac8a4",
  null
  
)

export default component.exports